import React, { useState, useContext } from 'react';
import { map } from 'lodash';
import classnames from 'classnames';
import Slider from '../../../components/slider';
import { BaseContext } from '../../../contexts';
import { customSliderSettings } from '../../../helper';
import { plansPageUpdateDimensions } from '../../../statistics';

const Plans = ({ onBack, onSelect }) => {
  const { plans } = useContext(BaseContext);
  const [ sliderSettings ] = useState(() => (customSliderSettings(plans)));
  const handleOnSelect = (plan) => () => {
    onSelect(plan);
  };
  const onRenderPage = () => {
    plansPageUpdateDimensions();
  };
  return (
    <div className="subscriptions white">
      <header className="sticky-header bolder">
        <button className="back-button" onClick={ onBack }>
          <span className="dash" />
        </button>
      </header>
      <div className="subscriptions-main slider">
        <h3 className="cloud-plans-title">Select the Cloud plan that’s right for you</h3>
        <Slider className="best-plans_grid" customSettings={ sliderSettings }>
          {
            map(plans, (plan) => (
              <div key={ plan.id } className="cloud-plan">
                <div className="cloud-plan__promotion">
                  {
                    !!plan.promotion &&
                    <>
                      <div className="promotion__icon">
                        <svg className="icon label"><use xlinkHref="#svg_label" /></svg>
                      </div>
                      <span className="promotion__text">{ plan.promotion }</span>
                    </>
                  }
                </div>
                <div className="cloud-plan-content">
                  <div className="cloud-plan__details">
                    <div className="details__header">
                      <h2 className="details__plan-name">{ plan.title }</h2>
                      <span className="details__price">{ plan.price }</span>
                    </div>
                    <div className="details__features">
                      {
                        map(plan.features, (feature, featureIndex) => (
                          <div
                            className={ classnames("features__item", feature.className) }
                            key={ featureIndex }
                          >
                            <span className="features__icon">
                              {
                                feature.image ? (
                                  <img
                                    className={ classnames("icon", feature.icon) }
                                    src={ feature.image }
                                    alt="phonesImage"
                                  />
                                ) : (
                                  <svg className={ classnames("icon", feature.icon) }>
                                    <use xlinkHref={ `#svg_${feature.icon}` } />
                                  </svg>
                                )
                              }
                            </span>
                            <p>{ feature.description }</p>
                          </div>
                        ))
                      }
                      <span className="pseudo-link learn-more">Learn more</span>
                    </div>
                  </div>
                  <div className="cloud-plan-bottom-part">
                    <p className="asterisk-note">
                      * Plus taxes and Verizon surcharges.
                      { ' ' }
                      Your Cloud plan will auto-renew at the monthly charge until you cancel.
                      { ' ' }
                      Cancel anytime in Verizon Cloud app.
                    </p>
                    <button className="button" onClick={ handleOnSelect(plan) }>
                      Select
                    </button>
                  </div>
                </div>
              </div>
            ))
          }
        </Slider>
      </div>
      <div ref={ onRenderPage } />
    </div>
  );
};

export default Plans;
